<template>
  <div class="slider">
    <div class="slider__wrapper" @click="onSliderClicked($event)">
      <div class="slider__runway" ref="runway" :data-name="item.name" :style="{width: item.runwayLength + 'px'}">
        <div class="slider__bar" :style="{width: item.barLength + 'px'}"></div>
        <div class="slider__button"
          @click.stop
          v-dragged="onDragged"
          :data-name="item.name"
          ref="sliderButton"
        ></div>
      </div>
    </div>

    <div class="slider__counter counter" v-if="showCounter">
      <div class="counter__input large" style="position: relative;">
        <input
          type="number"
          :step="step"
          @focus="onInputFocus"
          @keydown="onKeyDown($event)"
          @mousedown.stop
          @click.stop
          @change="onInputChange($event)"
          @blur="onBlur()"
          v-model="val"
          ref="inputEl"
        >
        <div class="counter__number-unit" v-if="numberUnit" @click.stop.prevent="focusInput">
          {{numberUnit}}
        </div>
        <div v-if="!hasInput" class="cover" style="position: absolute;top: 0; left: 0;width: 100%;height: 100%;"></div>
      </div>
      <div class="counter__btns" v-if="hasBtns">
        <div class="counter__btn up" @click="changeNum({type: 'up'})">+</div>
        <div class="counter__btn down" @click="changeNum({type: 'down'})">-</div>
      </div>
    </div>
  </div>
</template>

<script>
function mid (val, min, max) {
  return Math.min(Math.max(min, val), max);
}
export default {
  props: {
    runwaySize: {
      type: Number,
      default: 114
    },
    numberUnit: {
      type: String,
      default: ''
    },
    maxVal: {
      type: Number,
      default: 100
    },
    minVal: {
      type: Number,
      default: 0
    },
    numFixed: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    hasInput: {
      type: Boolean,
      default: true
    },
    hasBtns: {
      type: Boolean,
      default: false
    },
    showCounter: {
      type: Boolean,
      default: true
    },
    formatVal: {
      type: Function,
      default: function formatVal ({
        currentVal,
        step,
        numFixed,
        min,
        max
      } = {}) {
        let numVal = currentVal - 0;
        numVal = numVal < min ? min
          : numVal > max ? max
            : numVal;
        let strVal = '' + numVal;
        let parts = strVal.split('.');
        parts[0] = parts[0] || '0';
        parts[1] = parts[1] || '0';
        parts[1] = parts[1].slice(0, numFixed);
        // let b = parts[1];
        // if (b / 10 < step / 2) {
        //   b = 0;
        // } else if (b / 10 < step * 3 / 2) {
        //   b = (step * 10).toFixed(0);
        // } else {
        //   b = 0;
        //   parts[0] = parts[0] - 0 + 1
        // }
        // parts[1] = b;
        strVal = parts.join('.');
        if (strVal == '0.0') {
          strVal = '0';
        }
        return strVal;
      }
    },
    msg: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    const vm = this;
    return {
      val: 0,
      oldVal: 0,
      isMouseMoving: false,
      isKeyDown: false,
      item: {
        name: '',
        barLength: 0,
        runwayLength: vm.runwaySize,
        max: vm.maxVal,
        min: vm.minVal,
        valueChange: (vm.maxVal - vm.minVal).toFixed(vm.numFixed) - 0,
        cacheOffset: 0,
        prevMoveMark: 0
      }
    };
  },
  computed: {
    valueChange () {
      return (this.maxVal - this.minVal).toFixed() - 0;
    }
  },
  watch: {
    val: {
      handler (val, oldVal) {
        const vm = this;
        if (this.isKeyDown.key === 'Backspace') {
          return;
        }

        if (this.step < 1) {
          let input = '' + this.val;
          let arr = input.split('.');
          if (arr.length && arr[1] && arr[1].length >= this.numFixed) {
            arr[0] = arr[0] || '0';
            arr[1] = arr[1] || '0';
            arr[1] = arr[1].slice(0, this.numFixed);
            let num = arr.join('.') - 0 || 0;
            let _val = mid(num, vm.item.min, vm.item.max);
            vm.val = (_val - 0).toFixed(vm.numFixed);
            vm.updateDragByInput(vm.val - 0);
            vm.emitValue();
          }
          return;
        }

        f(this);

        function f (vm) {
          let _val = parseFloat(val);

          _val = mid(_val, vm.item.min, vm.item.max);

          vm.val = (_val - 0).toFixed(vm.numFixed);
          vm.updateDragByInput(vm.val - 0);
          vm.emitValue();
        }
      }
    },
    maxVal: {
      handler (val) {
        const vm = this;
        this.item = {
          ...this.item,
          max: val,
          valueChange: (vm.maxVal - vm.minVal).toFixed(vm.numFixed) - 0
        };
        if (this.val > val) {
          this.val = val;
        }
      }
    }
  },
  created () {
    if (this.runwaySize) {
      // this.item.runwayLength = this.runwaySize;
      this.item = {
        ...this.item,
        runwayLength: this.runwaySize
      };
    }
    // if (this.numberUnit) {
    //   this.item.runwayLength -= 16;
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.$parent.$el.addEventListener('click', () => {
        this.blurInput();
      });
    });
  },
  methods: {
    onSliderClicked (ev) {
      if (this.isMouseMoving) {
        return;
      }
      let sliderRect = ev.currentTarget.getBoundingClientRect();
      let button = $(ev.currentTarget).find('.slider__button');
      let pos = ev.clientX - sliderRect.left;
      if (this.step !== 1) {
        pos = this.stickyPos(pos);
      } else {

      }

      button[0].style.left = pos + 'px';
      this.item.barLength = pos;
      this.updateVal(pos);
      this.emitValue(true);
    },

    onDragged ({
      el,
      deltaX,
      offsetX,
      offsetY,
      clientX,
      first,
      last
    } = {}) {
      const vm = this;
      let runwayRect = this.$refs.runway.getBoundingClientRect() || {};
      let { runwayLength } = this.item;
      let pos = 0;

      if (first) {
        let el = window.document.activeElement;
        el && el.blur();
        this.oldVal = this.val;
        return;
      }

      if (last) {
        this.emitValue(true);
        this.isMouseMoving = false;
        return;
      }

      this.isMouseMoving = true;

      let l = parseInt(window.getComputedStyle(el)['left']) || 0;
      if (l <= 0 && deltaX < 0 || clientX < runwayRect.left) {
        pos = 0;
      } else if (l >= runwayLength && deltaX > 0 || clientX > runwayRect.right) {
        pos = runwayLength;
      } else {
        // pos = l + deltaX;
        pos = clientX - runwayRect.left;
        pos = this.stickyPos(pos);
      }
      if (pos < 0) {
        pos = 0;
      }
      if (pos > runwayLength) {
        pos = runwayLength;
      }

      el.style.left = pos + 'px';
      this.item.barLength = pos;

      this.updateVal(pos, last);
    },

    stickyPos (currentPos) {
      if (moveUnit < 1) {
        return currentPos;
      }
      let pos = currentPos;
      let { runwayLength, valueChange } = this.item;
      let moveUnit = runwayLength / valueChange * this.step;
      let passedMarks = pos / moveUnit;
      let int = Math.floor(passedMarks);
      let remain = pos % moveUnit;
      if (remain > moveUnit / 2) {
        pos = int * moveUnit + moveUnit;
      } else {
        pos = int * moveUnit;
      }

      return pos;
    },

    updateInputByDrag () {

    },

    updateDragByInput (val) {
      if (this.isMouseMoving) {
        return;
      }
      let { min, max } = this.item;
      val = val < min ? min
        : val > max ? max
          : val;
      let pos = (val - this.minVal) / this.item.valueChange * this.item.runwayLength;
      pos = this.stickyPos(pos);
      if (min === max) {
        val = max;
        pos = this.item.runwayLength;
      }
      this.$refs.sliderButton.style.left = pos + 'px';
      this.item.barLength = pos;
    },

    updateVal (pos, last) {
      let val = this.minVal + ((pos / this.item.runwayLength * this.item.valueChange).toFixed(this.numFixed) - 0);
      this.val = val;
      this.emitValue(last);
    },

    updateValFromOutside (val) {
      this.val = this.setNumFixed(val, this.numFixed);
      this.updateDragByInput(this.val);
    },

    onInputChange (ev) {
      if (typeof (this.val - 0) !== 'number') {
        this.val = this.oldVal;
      }
      let u = this.step;
      if (this.step !== 1) {
        // if (this.val % u !== 0) {
        //   this.val = (((this.val / u) | 0 ) * u).toFixed(this.numFixed);
        // }
        let strVal = this.formatVal({
          currentVal: this.val,
          step: this.step,
          numFixed: this.numFixed,
          max: this.item.max,
          min: this.item.min
        });
        strVal = this.setNumFixed(strVal, this.numFixed);
        this.val = strVal;
      }
      if (this.step === 1) {
        let num = ev.target.value - 0;
        num = num || 0;
        num = mid(num, this.item.min, this.item.max);
        let strVal = this.setNumFixed(num, this.numFixed);
        this.val = strVal;
      }
      if (ev.target.value === '') {
        this.val = this.oldVal;
        this.updateDragByInput(this.val);
        this.emitValue();
      }

      if (this.val === this.oldVal) {
        // this.blurInput();
        return;
      }
      this.emitValue();
    },
    onInputFocus () {
      this.oldVal = typeof (this.val - 0) === 'number' ? this.val : this.oldVal;
    },

    changeNum ({
      type
    } = {}) {
      if (type === 'up') {
        this.changeNumUp();
      }
      if (type === 'down') {
        this.changeNumDown();
      }

      this.$nextTick(() => {
        this.emitValue(true);
      });
    },
    changeNumUp () {
      if (this.val < this.item.max) {
        this.val = ((this.val - 0) + this.step).toFixed(this.numFixed);
      }
    },
    changeNumDown () {
      if (this.val > this.item.min) {
        this.val -= this.step;
        this.val = this.val.toFixed(this.numFixed);
      }
    },

    focusInput () {
      let el = this.$refs.inputEl;
      el.focus();
      var len = el.value.length;
      if (document.selection) {
        var sel = el.createTextRange();
        sel.moveStart('character', len);
        sel.collapse();
        sel.select();
      } else if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        el.selectionStart = el.selectionEnd = len;
      }
    },

    blurInput () {
      this.$refs.inputEl && this.$refs.inputEl.blur();
    },

    onKeyDown (ev) {
      this.isKeyDown = ev;

      if (ev.key === 'Enter') {
        this.blurInput();
      }
    },

    setNumFixed (input, fixed) {
      let num = input - 0;
      num = num || 0;
      return num ? num.toFixed(fixed) : '' + num;
    },

    emitValue (determinable) {
      // this.blurInput();
      this.$emit('updateValue', this.val - 0 || 0, determinable, this.msg, this.oldVal - 0 || 0);
    },

    onBlur () {
      if (this.val != this.oldVal) {
        this.emitValue(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../style/colors";

.slider {
  display: flex;
  align-items: center;
  height: 16px;

  &__runway {
    position: relative;
    width: 170px;
    height: 4px;
    border-radius: 4px;
    background-color: $c13;
    margin: 6px 0;
  }
  &__bar {
    height: 4px;
    border-radius: 4px;
    background-color: #474261;
  }
  &__button {
    position: absolute;
    top: -6px;
    margin-left: -8px;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    background-color: #474261;
    cursor: grab;
  }
}

.counter {
  display: flex;
  padding-left: 10px;

  &__input {
    display: flex;
    width: 30px;
    height: 30px;
    border: solid 1px #d9ddea;
    border-radius: 4px;

    &:focus-within {
      border: solid 1px #5778fb;
    }

    &.large {
      width: 46px;
    }

    & > input, & > .num {
      border-width: 0;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: transparent;
    }
  }

  &__number-unit {
    flex-shrink: 0;
    line-height: 28px;
    text-align: center;
    width: 16px;
  }

  &__btns {
    margin-left: 2px;
    width: 20px;
  }

  &__btn {
    width: 20px;
    height: 14px;
    line-height: 14px;
    background-color: #f0f0f8;
    cursor: pointer;

    &.up {
      border-radius: 0 4px 0 0;
      margin-bottom: 2px;
    }

    &.down {
      border-radius: 0 0 4px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/content/slider.vue